import ScrollMagic from 'scrollmagic';

export function scrollMagic() {
  let controller = new ScrollMagic.Controller();

  let fadeIn = document.querySelectorAll('.js-scrollAnimation');

  for (let i = 0; i < fadeIn.length; i++) {
    let tag = fadeIn[i];

    const windowWidth = window.innerWidth;

    if (windowWidth > 768) {
      new ScrollMagic.Scene({
        triggerElement: tag,
        triggerHook: 'onEnter',
        offset: 86,
      })
        .setClassToggle(tag, 'is-animated')
        .addTo(controller);
    } else {
      console.log(windowWidth);
      new ScrollMagic.Scene({
        triggerElement: tag,
        triggerHook: 'onEnter',
        offset: 50,
      })
        .setClassToggle(tag, 'is-animated')
        .addTo(controller);
    }
  }
}
